"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY = exports.Empty = void 0;

var types_1 = require("@web3-react/types");

var Empty = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(Empty, _types_1$Connector);

  var _super = _createSuper(Empty);

  function Empty() {
    _classCallCheck(this, Empty);

    return _super.apply(this, arguments);
  }

  _createClass(Empty, [{
    key: "activate",
    value:
    /**
     * No-op. May be called if it simplifies application code.
     */
    function activate() {
      void 0;
    }
  }]);

  return Empty;
}(types_1.Connector);

exports.Empty = Empty; // @ts-expect-error actions aren't validated and are only used to set a protected property, so this is ok

exports.EMPTY = new Empty();